/*
 *
 * TermsAndConditionsDetailPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Feb-2025
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  title: {
    id: 't.app.terminalsManagement.disputeless.popup.tac.details.title',
    defaultMessage: 'Terms and Conditions details'
  },
  generalInformations: {
    id: 't.app.terminalsManagement.disputeless.form.generalInformations',
    defaultMessage: 'General information'
  },
  termsCond: {
    id: 't.app.terminalsManagement.disputeless.details.termsCond',
    defaultMessage: 'Terms and conditions'
  },
  type: {
    id: 't.app.terminalsManagement.disputeless.form.tac.type',
    defaultMessage: 'Type*'
  },
  name: {
    id: 't.app.terminalsManagement.disputeless.details.identifier',
    defaultMessage: 'Name'
  },
  reservationType: {
    id: 't.app.terminalsManagement.disputeless.form.tac.reservationType',
    defaultMessage: 'Reservation type*'
  },
  language: {
    id: 't.app.terminalsManagement.disputeless.form.tac.language',
    defaultMessage: 'Language'
  },
  text: {
    id: 't.app.terminalsManagement.disputeless.form.tac.text',
    defaultMessage: 'Text'
  },
  CANCELLATION_CONDITION: {
    id: 't.app.terminalsManagement.disputeless.form.tac.cancellationCondition',
    defaultMessage: 'Cancellation condition'
  },
  STRUCTURE_CONDITION: {
    id: 't.app.terminalsManagement.disputeless.form.tac.structureCondition',
    defaultMessage: 'Structure condition'
  },
  PREPAID_REFUNDABLE: {
    id: 't.app.terminalsManagement.disputeless.form.tac.prepaidRefundable',
    defaultMessage: 'Prepaid refundable'
  },
  PREPAID_NOT_REFUNDABLE: {
    id: 't.app.terminalsManagement.disputeless.form.tac.prepaidNotRefundable',
    defaultMessage: 'Prepaid not refundable'
  },
  GUARANTEED_NOSHOW: {
    id: 't.app.terminalsManagement.disputeless.form.tac.guaranteedNoShow',
    defaultMessage: 'Guaranteed no show'
  },
  GUARANTEED_PENALTY: {
    id: 't.app.terminalsManagement.disputeless.form.tac.guaranteedPenalty',
    defaultMessage: 'Guaranteed penalty'
  },
  BUNDLE: {
    id: 't.app.terminalsManagement.disputeless.form.tac.bundle',
    defaultMessage: 'Bundle'
  },
  remove: {
    id: 't.app.terminalsManagement.disputeless.popup.tac.details.button.delete',
    defaultMessage: 'Delete terms'
  },
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  Enabled: {
    id: 't.app.terminalsManagement.disputeless.details.Enabled',
    defaultMessage: 'Enabled'
  },
  Disabled: {
    id: 't.app.terminalsManagement.disputeless.details.Disabled',
    defaultMessage: 'Disabled'
  },
  confirm: {
    id: 't.app.project.btn.confirm',
    defaultMessage: 'Confirm'
  }
})
